// Rough Notation pro podtržení nadpisů v článcích
import { annotate } from 'rough-notation';

function applyRoughNotation() {
  // Najdeme všechny h1, h2 a h3 elementy v článcích
  const headingElements = document.querySelectorAll('article p>a:not(.btn)');  
  if (headingElements.length > 0) {
    // Vytvoříme anotace pro všechny nadpisy
    const annotations = Array.from(headingElements).map(element => {
      // Přidáme span kolem textu pro lepší kontrolu
      const text = element.textContent;
      element.innerHTML = `<span class="heading-text">${text}</span>`;
      
      const textSpan = element.querySelector('.heading-text');
      
      return annotate(textSpan, {
        type: 'underline',
        color: '#000000', // Černá barva
        strokeWidth: 2,
        padding: 1,
        animate: true,
        animationDuration: 500,
        multiline: true,
        iterations: 1
      });
    });
    
    // Spustíme animaci postupně - jeden po druhém
    setTimeout(() => {
      annotations.forEach((annotation, index) => {
        setTimeout(() => {
          annotation.show();
        }, index * 300); // 300ms zpoždění mezi každým nadpisem
      });
    }, 500);
  }
}

document.addEventListener('DOMCoźntentLoaded', applyRoughNotation);

// Pro Turbo navigaci (Rails 7+)
document.addEventListener('turbo:load', applyRoughNotation);
